document.addEventListener("DOMContentLoaded", function() {
    var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));
  
    if ("IntersectionObserver" in window) {
      var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(video) {
          if (video.isIntersecting) {
            for (var source in video.target.children) {
              var videoSource = video.target.children[source];
              if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                videoSource.src = videoSource.dataset.src;
              }
            }
  
            video.target.load();
            video.target.classList.remove("lazy");
            lazyVideoObserver.unobserve(video.target);
          } 
        });
      });
  
      lazyVideos.forEach(function(lazyVideo) {
        lazyVideoObserver.observe(lazyVideo);
      });
    }
  });

    


  $('.ha_ugc_video_start').click(function(){
    $(this).hide();
    var video = $(this).closest('.ha_ugc_video_out').find('video')[0];
      if (video) {

        video.play();
    } 
  });

  $(document).on("click",".arcf_var_cell",function() {
    // var dataId = $(this).find('.arCf_variant').attr('data-id');
    $('.cf_price_note').removeClass('active');
    $(this).closest('.arcf_var_cell').find('.cf_price_note').addClass('active');
    // setTimeout(function(){
    //   if ($('.arCf_variant[data-id="'+dataId+'"').hasClass('arCfVar_active')){
    //     console.log('should be not clciked'); 
    //   } 
    //   else{
    //     console.log('should be clciked', dataId);
    //     // $('.arCf_variant[data-id="'+dataId+'"]').trigger('click');
    //   }
    // },100);
  });


  $('.naRosebtn').click(function(){
    $('html, body').animate({
        scrollTop: $(".naProduct").offset().top-150
    }, 500);
  });


  
  $(document).on("click",".qz_summary-btn.atc_btn-main_quiz",function(evt) {
    evt.preventDefault();

    var currentId = $('.arCf_variant.arCfVar_active').attr('data-id');
    var sellingId = $('.arCf_variant.arCfVar_active').attr('data-sellingplan');

    var subOn = false;
    if ($('#subscribeAr').is(':checked')){
      subOn = true;
    }

    if (subOn == true){
      $.ajax({
            type: "POST",
            url: "/cart/clear.js",
            success: function () {
                $.ajax({
                    type: "POST",
                    url: "/cart/add.js",
                    data: {
                        id: currentId,
                        selling_plan: sellingId,
                        quantity: 1
                    },
                    success: function () {
                        window.location.href = '/checkout';
                    }
                });
            }
      });
    }
    else{
       $.ajax({
            type: "POST",
            url: "/cart/clear.js",
            success: function () {
                $.ajax({
                    type: "POST",
                    url: "/cart/add.js",
                    data: {
                        id: currentId,
                        quantity: 1
                    },
                    success: function () {
                        window.location.href = '/checkout';
                    }
                });
            }
        });
    }
    

  });


  $(document).on("click",".qz_summary-btn.scroll",function(evt) {
    evt.preventDefault();
    $('html, body').animate({
        scrollTop: $(".qz_results-product-outer").offset().top
    }, 500);
  });



$(document).on("click",".md_faq_block",function() {
// $('.md_faq_block').click(function(){
  if ($(this).hasClass('active')){
      $('.md_faq_block').removeClass('active');
      $('.md_faq_block').find('.md_faq_block_content').slideUp();
  }
  else{
      $('.md_faq_block').removeClass('active');
      $('.md_faq_block').find('.md_faq_block_content').slideUp();
      $(this).find('.md_faq_block_content').slideDown();
      $(this).addClass('active');
  }
});

$('.glp_selector_cell').click(function(){
  $('.glp_selector_cell').removeClass('active');
  $(this).addClass('active');

  var data = $(this).attr('data-id');
  var isChecked = $('.arCf_toggle input').is(':checked');

  if (data == '1'){
    // $('.arCf_variant[data-id="49093233639772"]').trigger('click');
    if (isChecked) {

    } else {
      $('.arCf_toggle input').trigger('click');
    }
  }
  else if (data == '2'){
    // $('.arCf_variant[data-id="49093233672540"]').trigger('click');
    if (isChecked) {

    } else {
      $('.arCf_toggle input').trigger('click');
    }
  }
  else if (data == '3'){
    // $('.arCf_variant[data-id="49093233705308"]').trigger('click');
    if (isChecked) {

    } else {
      $('.arCf_toggle input').trigger('click');
    }
  }
  else if (data == '4'){
    // $('.arCf_variant[data-id="49093233639772"]').trigger('click');
    if (isChecked) {
      $('.arCf_toggle input').trigger('click');
    } else {
      
    }
  }
});





setTimeout(function(){
  var currentUrl = String(window.location.href);
  // if (currentUrl.indexOf('ultimate-mb-capsules') != -1){
  //   $('#subscribeAr').trigger('click');
  // }
  if (currentUrl.indexOf('/products/ultimate-methylene') != -1){
    if (currentUrl.indexOf('/products/ultimate-methylene-blue') != -1){
    }
    else{
      window.location.href = '/products/ultimate-methylene-blue';
    }
  }
},200);



